import React, { useState } from "react";
import { useAuth } from "../../../../utils/useAuth";
import { FiEye, FiEyeOff } from "react-icons/fi";
import toast from "react-hot-toast";
import { changePasswordApi } from "../../../../api/website/profile/profileAPI";

const PasswordInput = ({ label, name, value, onChange }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="text-xs text-gray-500">{label}</label>
      <div className="relative mt-1">
        <input
          name={name}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          className="w-full border p-2.5 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
        >
          {show ? <FiEyeOff /> : <FiEye />}
        </button>
      </div>
    </div>
  );
};

const ChangePassword = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    const { oldPassword, newPassword, confirmPassword } = form;
    if (!oldPassword || !newPassword) {
      return toast.error("Please fill in all fields");
    }
    if (newPassword.length < 6) {
      return toast.error("New password must be at least 6 characters");
    }
    if (newPassword !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    setSaving(true);
    await changePasswordApi(user.id, { oldPassword, newPassword }, () =>
      setForm({ oldPassword: "", newPassword: "", confirmPassword: "" }),
    );
    setSaving(false);
  };

  return (
    <div className="space-y-6">
      <p className="font-bold uppercase text-sm text-gray-600">
        Change Password
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
        <div className="md:col-span-2">
          <PasswordInput
            label="Current Password"
            name="oldPassword"
            value={form.oldPassword}
            onChange={handleChange}
          />
        </div>
        <PasswordInput
          label="New Password"
          name="newPassword"
          value={form.newPassword}
          onChange={handleChange}
        />
        <PasswordInput
          label="Confirm New Password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
        />
      </div>

      <div className="flex justify-start">
        <button
          onClick={handleSubmit}
          disabled={saving}
          className="px-6 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 duration-300 disabled:opacity-50"
        >
          {saving ? "Updating..." : "Update Password"}
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
